// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"charts_customTooltip__2BvBD","arrow":"charts_arrow__2AFQX","productionInDay":"charts_productionInDay__1rS3S"};